/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpContextToken
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpCacheService } from './http-cache.service';
import { ROUTE_LOGIN } from 'src/app/auth/components/login/services/login.service';

export const CLEAR_CACHE = new HttpContextToken<boolean>(() => false);
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private cacheService: HttpCacheService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes(ROUTE_LOGIN)) {
      return next.handle(req);
    }
    if (req.method !== 'GET' || req.context.get(CLEAR_CACHE) === true) {
      this.cacheService.delete(req.url);
      return next.handle(req);
    }
    const cachedResponse: HttpResponse<any> = this.cacheService.get(req.url);
    if (cachedResponse) {
      return of(cachedResponse);
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.cacheService.insert(req.url, event);
        }
      })
    );
  }
}
